import { render } from "./Contests.vue?vue&type=template&id=2e0bc748&scoped=true"
import script from "./Contests.vue?vue&type=script&lang=js"
export * from "./Contests.vue?vue&type=script&lang=js"

import "./Contests.vue?vue&type=style&index=0&id=2e0bc748&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Kuppen_front/Kuppen_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0bc748"]])

export default __exports__